import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";

export const fetchAllMintpacks = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_ALL_MINTPACKS,
        
    }
};

export const fetchAllMintpacksSuccess = (data: any, recommendedPacks?: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_ALL_MINTPACKS_SUCCESS,
        payload: {
            data: data,
            recommendedPacks: recommendedPacks
        }
    }
};

